import api from '../configs/api.config';
import { CreateUserRequest, UpdateUserRequest, UserSummary } from '../types/auth.types';

export const getUsers = async () => {
  const { data } = await api.get<UserSummary[]>('/Users', { silent: true });
  return data;
};

export const getAssignableRoles = async () => {
  const { data } = await api.get<Record<string, string[]>>('/Users/roles', { silent: true });
  return data;
};

export const createUser = async (request: CreateUserRequest) => {
  const { data } = await api.post<UserSummary>('/Users', request);
  return data;
};

export const updateUser = async (id: string, request: UpdateUserRequest) => {
  const { data } = await api.put<UserSummary>(`/Users/${id}`, request);
  return data;
};

export const resetUserPassword = async (id: string, temporaryPassword: string) => {
  const { data } = await api.post<UserSummary>(`/Users/${id}/reset-password`, {
    temporaryPassword
  });
  return data;
};
